import { useState, useEffect } from 'react'
import { useEngagementApi } from './use-engagement-api'
import type { FieldMetadata, EngagementFieldMetadata } from '@/types/api/engagement'

export function useFieldMetadata(enabled: boolean = true) {
  const [metadata, setMetadata] = useState<EngagementFieldMetadata>({})
  const [loading, setLoading] = useState(enabled)
  const [error, setError] = useState<Error | null>(null)
  const api = useEngagementApi()
  
  useEffect(() => {
    if (!enabled) {
      setLoading(false)
      return
    }
    
    async function fetchMetadata() {
      try {
        const data = await api.getFieldMetadata()
        setMetadata(data)
        setError(null)
      } catch (err) {
        console.error('Failed to fetch field metadata:', err)
        setError(err instanceof Error ? err : new Error('Failed to fetch field metadata'))
        setMetadata({}) // Reset to empty on error
      } finally {
        setLoading(false)
      }
    }
    fetchMetadata()
  }, [enabled, api])
  
  // Lookup with array index normalization
  const getMetadata = (propertyPath: string, fieldName: string): FieldMetadata | undefined => {
    // Construct full path: propertyPath + fieldName
    const fullPath = propertyPath ? `${propertyPath}/${fieldName}` : fieldName
    
    // Remove array indices: "Milestones/0/StatusCode" -> "Milestones/StatusCode"
    const normalizedPath = fullPath.replace(/\/\d+\//g, '/')
    
    return metadata[normalizedPath]
  }
  
  return { metadata, getMetadata, loading, error }
}

